import React from 'react';
import Page from '../../layout/Page';
import ReferralProgram from './ReferralProgram';
import RoleProtected, { userRoles } from '../../RoleProtected';

const ReferralProgramPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='Referral Program' icon='mobile'>
            <ReferralProgram />
        </Page>
    </RoleProtected>
);

export default ReferralProgramPage;
